import { HimuraInject } from 'himura';

@HimuraInject.NamedService('CommonConfig')
export class CommonConfig {

    public appTitle: string = 'RIFO Epic Web';

    public apiHost: string = 'https://api.realjaja.com/radar-api';

    public cmisapiHost: string = 'https://api.realjaja.com';

    public blogService: string = 'https://api.realjaja.com/blogArticle';
    public couponService: string = 'https://api.realjaja.com/coupon-srv/v1.1/';

    public tradeService: string = 'https://api.realjaja.com/trade-srv/v1.1/';

    public houseRecommendService: string = 'https://api.realjaja.com/house/recommend';
    public trendingReportService: string = 'https://i42kjcxyr2.execute-api.us-east-1.amazonaws.com/prod';
    public vendorService: string = 'https://3jpt6hkct4.execute-api.us-east-1.amazonaws.com/prod';

    public monerisPsStoreId: string = 'BLVL2tore3';

    public monerisHppKey: string = 'hpD88XM4OX86';
    public googleAppKey: string = 'AIzaSyBQ5QtkRuPhfscwJzvMKRG2_JkaeGYvHgA';

    public analysisService: string = 'https://ricenter.realjaja.com/ricenter-analysis';
    public mnsService: string = 'https://ricenter.realjaja.com/ricenter-mns';
    public mnsQueueName: string = 'prod-email';
    public housePicPlaceHolder: string = 'https://files.realjaja.com/rifo-web/epic/imgs/2x/placeholders/house-placeholder-new%402x.png';

    public userPicPlaceHolder: string = 'https://files.realjaja.com/rifo-web/epic/imgs/rifo-design/user_placeholder.png';
    public bannerHolder: string = 'https://files.realjaja.com/rifo-web/epic/imgs/epic-banners/img01.png';

    public epicLogo: string = 'https://files.rifo.co/rifo-web/epic/imgs/rifo-design/epic-logos/rifo_logo.svg';

    public fourOFourImg: string = 'https://files.realjaja.com/rifo-web/epic/imgs/rifo-design/epic-404/404.jpg';
    public allDeviceImg: string =
        'https://files.realjaja.com/rifo-web/epic/imgs/rifo-design/epic-header/all-devices.816ce01138bc046f386ad7e393b709af%402x.png';

    public rifoDesignAssetsUrl: string = 'https://files.realjaja.com/rifo-web/epic/imgs/rifo-design';

    public radarHost: string = 'https://radar.rifo.co';

    public smartSelectionService: string = 'https://tims.realjaja.com/api/smartSelection';
    public wwwDebugMode = false;

    public loggerDebugMode = false;

    public routesEpic: string[] = [];

    public routesFrontStore: string[] = [];

    public dateFormat = 'YYYY-MM-DD';

    public userUrlSuffix = 'rifo.co';

    public dailyReportNumber = 100;

    public soldInXDays = 7;

    public worldWide = ['www.rifo.co', 'www.rifo.ca', 'www.riforealty.com']; // header �Ƿ���ʾ report ��Ŀ

    public weekdays: string[] = [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
    ];

    public rifoContactPhone: string = '+14168839666';
    public marketingAdUrl = 'https://www.event.rifo.ca/rifo-en';
    public createLeadUrl = 'https://qoewyobuul.execute-api.us-east-1.amazonaws.com/prod/leads/create';
public googleTranslateAPI = 'https://lyx5ew1sxg.execute-api.us-east-1.amazonaws.com/prod/translate';
public serverlessAPI = 'https://prod-sls.realjaja.com';
    constructor() { }
}
